import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { DashboardDevice, DashboardInstallationData } from '@vi-iot/client';

import { KanbanBoardHelperService, KanbanBoardStore, standaloneImagePath } from '@store';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PillComponent } from '@components';
import { TranslateModule } from '@ngx-translate/core';
import { PillType } from '../../../../shared/components/pill/pill.model';
import { AggregatedStatusPillPipe } from '../../pipes/aggregated-status-pill/aggregated-status-pill.pipe';
import { DashboardAnomalyPillPipe } from '../../pipes/dashboard-anomaly-pill/dashboard-anomaly-pill.pipe';
import { DashboardOperatingModePipe } from '../../pipes/dashboard-operating-mode/dashboard-operating-mode.pipe';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { BrandLogo } from 'src/app/+installations/helpers/brand-logo';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-kanban-quick-view-header',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PillComponent,
    DashboardAnomalyPillPipe,
    DashboardOperatingModePipe,
    AggregatedStatusPillPipe,
    MatIconModule,
    DragScrollComponent,
    DragScrollItemDirective,
    MatTooltipModule,
  ],
  templateUrl: './kanban-quick-view-header.component.html',
  styleUrls: ['./kanban-quick-view-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KanbanQuickViewHeaderComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() installation: DashboardInstallationData;
  @Input() selectedDeviceIndex: number;
  @Input() selectedDevice: DashboardDevice;

  readonly pillType = PillType;
  readonly standaloneImagePath = standaloneImagePath;

  installationHeaderLabel: string;

  ngOnInit(): void {
    this.installationHeaderLabel = this.kanbanBoardHelperService.getInstallationHeaderLabel(
      this.installation
    );

    if (this.installation) {
      if (this.installation) {
        this.installation = BrandLogo.updateDashboardInstallationDataBrandLogo(this.installation);
      }
    }
  }

  constructor(
    public kanbanBoardHelperService: KanbanBoardHelperService,
    private kanbanBoardStore: KanbanBoardStore
  ) {}

  changeSelectedDeviceIndex(index: number): void {
    if (index !== this.selectedDeviceIndex) {
      this.kanbanBoardStore.changeSelectedDeviceIndex(index);
    }
  }
}
